export default __webpack_public_path__ + "static/46577247_l-a6c7748dd8da2dd9307fad6b4ed2206f.jpg";